var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5H3.16667H16.5",
    stroke: "#F44343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.00001C15.8333 4.44772 15.3856 4.00001 14.8333 4.00001C14.281 4.00001 13.8333 4.44772 13.8333 5.00001H15.8333ZM4.16666 5.00001C4.16666 4.44772 3.71895 4.00001 3.16666 4.00001C2.61438 4.00001 2.16666 4.44772 2.16666 5.00001H4.16666ZM4.66666 5.00001C4.66666 5.55229 5.11438 6 5.66666 6C6.21895 6 6.66666 5.55229 6.66666 5.00001H4.66666ZM11.3333 5.00001C11.3333 5.55229 11.781 6 12.3333 6C12.8856 6 13.3333 5.55229 13.3333 5.00001H11.3333ZM13.8333 5.00001V16.6667H15.8333V5.00001H13.8333ZM13.8333 16.6667C13.8333 17.0349 13.5349 17.3333 13.1667 17.3333V19.3333C14.6394 19.3333 15.8333 18.1394 15.8333 16.6667H13.8333ZM13.1667 17.3333H4.83333V19.3333H13.1667V17.3333ZM4.83333 17.3333C4.46514 17.3333 4.16666 17.0349 4.16666 16.6667H2.16666C2.16666 18.1394 3.36057 19.3333 4.83333 19.3333V17.3333ZM4.16666 16.6667V5.00001H2.16666V16.6667H4.16666ZM6.66666 5.00001V3.33334H4.66666V5.00001H6.66666ZM6.66666 3.33334C6.66666 2.96515 6.96514 2.66667 7.33333 2.66667V0.666672C5.86057 0.666672 4.66666 1.86058 4.66666 3.33334H6.66666ZM7.33333 2.66667H10.6667V0.666672H7.33333V2.66667ZM10.6667 2.66667C11.0349 2.66667 11.3333 2.96515 11.3333 3.33334H13.3333C13.3333 1.86058 12.1394 0.666672 10.6667 0.666672V2.66667ZM11.3333 3.33334V5.00001H13.3333V3.33334H11.3333Z",
    fill: "#F44343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fde5bd0d.svg";
export { ForwardRef as ReactComponent };